import type { OrgInfo } from '/#/store';

import { defineStore } from 'pinia';
import { store } from '/@/store';
import { getOrgManager } from '@lingtu/user';
import { useUserStoreWithOut } from './user';
import { apis } from '/@/apis';
import { setApi } from '@lingtu/user/src/init';

const userStore = useUserStoreWithOut();

interface OrgState {
  orgInfo: OrgInfo | null;
  adminPerm: number;
}

export const useOrgStore = defineStore({
  id: 'org',
  state: (): OrgState => ({
    orgInfo: null,
    adminPerm: 0,
  }),
  getters: {
    isTeam() {
      return this.orgInfo?.type === 'org';
    },
    isPersonal() {
      return this.orgInfo?.type === 'personal';
    },
  },
  actions: {
    setOrgInfo(orgInfo) {
      this.orgInfo = {
        ...this.orgInfo,
        ...orgInfo,
      };

      if (this.orgInfo?.id) {
        userStore.saveOrgId(this.orgInfo.id);
      }
    },

    async getOrgInfo(refetch = false) {
      const orgManager = getOrgManager();
      const orgInfo = await orgManager.getOrg(refetch);
      this.setOrgInfo(orgInfo);
      return orgInfo;
    },

    async getOrgAdminConfig() {
      const result = await apis.user.getOrgAdminConfig();
      this.adminPerm = result.adminPerm;
    },
    async setOrgAdminConfig(adminPerm: number) {
      await apis.user.updateOrgAdminConfig({
        adminPerm,
      });
      this.adminPerm = adminPerm;
    },
  },
});

// Need to be used outside the setup
// 需要在设置之外使用
export function useOrgStoreWithOut() {
  return useOrgStore(store);
}
